import styled from 'styled-components';

export const Styled = styled.div`
    .custom-title {
        position: relative;
        margin: 0;
        margin-bottom: 24px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-weight: inherit !important;
        font-size: inherit !important;

        .custom-text {
            color: #303641;
            margin: 0;
        }
        .icon {
            width: 42px;
            height: 42px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            border-radius: 6px;
            margin-bottom: 10px;
            .material-icons {
                font-size: 20px;
            }
        }
        &.highlighted::after {
            content: '';
            width: 16px;
            height: 4px;
            border-radius: 23px;
            display: block;
            margin-top: 10px;
        }
        &.color-primary {
            &::after,
            .icon {
                background-color: var(--mui-palette-primary-main);
            }
        }
        &.color-secondary {
            &::after,
            .icon {
                background-color: var(--mui-palette-secondary-main);
            }
        }
        &.weight-default {
            .custom-text {
                font-weight: inherit !important;
            }
        }
        &.weight-thin {
            .custom-text {
                font-weight: 300 !important;
            }
        }
        &.weight-normal {
            .custom-text {
                font-weight: 600 !important;
            }
        }
        &.weight-bold {
            .custom-text {
                font-weight: 700 !important;
            }
        }

        &.size-small {
            .custom-text {
                font-size: 16px !important;
            }
        }
        &.size-middle {
            .custom-text {
                font-size: 18px !important;
            }
        }
        &.size-large {
            .custom-text {
                font-size: 22px !important;
            }
            &.highlighted::after {
                width: 20px;
                height: 5px;
            }
        }

        &.align-left {
            align-items: flex-start;
            .custom-text {
                text-align: left;
            }
        }
        &.align-center {
            align-items: center;
            .custom-text {
                text-align: center;
            }
        }
        &.align-right {
            align-items: flex-end;
            .custom-text {
                text-align: right;
            }
        }
    }
`;
